module.exports = __webpack_public_path__ + "static/media/dartsafearea.36b6faa2.svg";